import { Search } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AVAILABILITY } from "@/components/site/CatalogueControls";

const Pick = ({ value, onChange, options, placeholder, testId }) => (
  <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
    <SelectTrigger className="h-11 w-full rounded-xl bg-white sm:w-44" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      <SelectItem value="all">{placeholder}</SelectItem>
      {options.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`${testId}-${v.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{l}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const InventoryToolbar = ({ f, set, categories }) => (
  <div className="grid gap-3 sm:flex sm:flex-wrap" data-testid="inventory-toolbar">
    <label className="relative sm:flex-1 sm:min-w-[220px]">
      <Search className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[#8B5A2B]" />
      <input value={f.q} onChange={(e) => set({ q: e.target.value })} placeholder="Search inventory…" className="h-11 w-full rounded-xl border border-[#E5E0D8] bg-white pl-10 pr-3 outline-none focus:border-[#C59B27]" data-testid="inventory-search-input" />
    </label>
    <div className="grid grid-cols-2 gap-3 sm:flex">
      <Pick value={f.category} onChange={(v) => set({ category: v })} placeholder="All categories" testId="inventory-category-filter" options={(categories || []).map((c) => [c.name, c.name])} />
      <Pick value={f.availability} onChange={(v) => set({ availability: v })} placeholder="Any status" testId="inventory-status-filter" options={AVAILABILITY.map((a) => [a, a])} />
      <Pick value={f.published} onChange={(v) => set({ published: v })} placeholder="Published & hidden" testId="inventory-published-filter" options={[["true", "Published"], ["false", "Hidden"]]} />
      <Select value={f.sort} onValueChange={(v) => set({ sort: v })}>
        <SelectTrigger className="h-11 w-full rounded-xl bg-white sm:w-44" data-testid="inventory-sort"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="updated:desc">Recently updated</SelectItem>
          <SelectItem value="name:asc">Name A–Z</SelectItem>
          <SelectItem value="stock:asc">Stock: low first</SelectItem>
          <SelectItem value="stock:desc">Stock: high first</SelectItem>
          <SelectItem value="created:desc">Newest added</SelectItem>
        </SelectContent>
      </Select>
    </div>
  </div>
);
